import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import * as msTeams from "@microsoft/teams-js";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  adaptV4Theme,
  Box,
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  Theme,
  ThemeProvider,
} from "@mui/material";
import { Fragment, Suspense, useMemo } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./app.scss";
import { AppInsightsContextProvider } from "./appinsights/appinsightscontext";
import TICK from "./assets/images/tick.svg";
import { Spinner } from "./components/ui-helpers/spinner";
import { AppRoutes } from "./routes/routes";
declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

interface IApp {
  pca: PublicClientApplication;
  palette?: any;
}
const App = ({ pca, palette }: IApp) => {
  msTeams.initialize();
  const theme = useMemo(
    () =>
      createTheme(
        adaptV4Theme({
          palette: { ...palette },
          overrides: {},
          typography: {
            fontFamily: [
              "Segoe UI",
              "Roboto",
              "Helvetica",
              "Arial",
              "sans-serif",
            ].join(","),
            h2: {
              fontSize: "1.5rem",
              fontStyle: "normal",
              lineHeight: "48px",
            },
            h6: {
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: `"Segoe UI","Roboto", "Helvetica", "Arial", sans-serif`,
            },
            subtitle1: {
              fontSize: "1.125rem",
              fontStyle: "normal",
              lineHeight: "24px",
            },
            subtitle2: {
              fontSize: "1rem",
              fontStyle: "normal",
              lineHeight: "24px",
            },
            allVariants: {
              color: "#2E282A",
            },
          },
        })
      ),
    [palette]
  );

  return (
    <BrowserRouter>
      <AppInsightsContextProvider>
        <MsalProvider instance={pca}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Switch>
                <Suspense fallback={<Spinner />}>
                  <Fragment>
                    <main>
                      <AppRoutes />
                      <ToastContainer
                        hideProgressBar
                        icon={({ type }: any) => {
                          if (type === "success")
                            return (
                              <Box className="img_container">
                                <img
                                  src={TICK}
                                  alt="tick"
                                  height={"16px"}
                                  width={"16px"}
                                />
                              </Box>
                            );
                          if (type === "error") {
                            return (
                              <Box>
                                <InfoOutlinedIcon
                                  height={"16px"}
                                  width={"16px"}
                                />
                              </Box>
                            );
                          }
                        }}
                        closeButton={<CloseIcon sx={{ color: "#5F5F5F" }} />}
                      />
                    </main>
                  </Fragment>
                </Suspense>
              </Switch>
            </ThemeProvider>
          </StyledEngineProvider>
        </MsalProvider>
      </AppInsightsContextProvider>
    </BrowserRouter>
  );
};

const mapStateToProps = ({ themeReducer: { palette } }: any) => ({
  palette,
});
export default connect(mapStateToProps, null)(App);
